/**
 * kind_legend_controller.js — the visit colour key shows only the kinds on screen (Stimulus).
 *
 * Hosted by templates/calendar/_kind_legend.html under the calendar and the
 * Dispatch board. The server renders one item per kind of work
 * (CalendarEvent.visit_kinds), all hidden; this shows an item while the scope
 * element (data-kind-legend-scope-value) holds a visit drawn in that kind, read
 * from the visit-kind-<slug> class the visit already carries. Nothing here
 * knows a colour or a kind: the classes and the server's list are the owners.
 *
 * The scope re-renders on its own (FullCalendar on every view or date change,
 * the board's lanes frame after a move), so a MutationObserver re-reads it,
 * at most once per animation frame.
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["item"];
    static values = { scope: String };

    connect() {
        this._scope = document.querySelector(this.scopeValue);
        if (!this._scope) return;
        this._frame = null;
        this._observer = new MutationObserver(() => this._scheduleSync());
        this._observer.observe(this._scope, { childList: true, subtree: true });
        this._sync();
    }

    disconnect() {
        if (this._observer) this._observer.disconnect();
        if (this._frame) cancelAnimationFrame(this._frame);
    }

    _scheduleSync() {
        if (this._frame) return;
        this._frame = requestAnimationFrame(() => {
            this._frame = null;
            this._sync();
        });
    }

    _sync() {
        this.itemTargets.forEach((item) => {
            item.hidden = !this._scope.querySelector(`.visit-kind-${item.dataset.kind}`);
        });
    }
}
